export const FLAG_ENABLE_INCLUDE_ATTACHMENTS = false;
export const FLAG_ENABLE_IS_READ_RECEIPT_CHECKBOX = false;
